import React from 'react';
const EmojiGrid = ({ emojis, baseProductIndex, componentIndex, productIndex, monogrammingSide, selectEmoji }) => {
    return (React.createElement("div", { className: "monogramming__emojis" }, emojis.map((emoji, emojiIndex) => {
        return (React.createElement("button", { className: `emoji ${emoji.selected && 'selected'}`, key: emojiIndex, onClick: () => selectEmoji(baseProductIndex, componentIndex, productIndex, emojiIndex, monogrammingSide) },
            React.createElement("div", { className: "emoji__snippet", dangerouslySetInnerHTML: { __html: emoji.svg_code } })));
    })));
};
export default EmojiGrid;
